const cowbell = 'cowbell';
const agency = 'agency';
const policyholder = 'policyholder';
const da = 'da';
const cluster = 'cluster';
const carrier = 'carrier';
const pool = 'pool';
const mssp = 'mssp';
const vendor = 'vendor';
const reinsurer = 'reinsurer';
const premiumprocessor = 'premiumprocessor';
const unknown = 'unknown';

export const personaAliases = {
  cowbell,
  admin: cowbell,
  agency,
  customer: policyholder,
  policyholder,
  da,
  cluster,
  carrier,
  pool,
  mssp,
  vendor,
  reinsurer,
  premiumprocessor,
  unknown,
} as const;
